export default function PHP_xml_set_start_namespace_decl_handler() {
  return (
    <div>
      <h1>PHP_xml_set_start_namespace_decl_handler</h1>
    </div>
  );
}
